import colorPicker from "./components/color-picker.vue";

if ($("#vue-registrator").length) {
    new Vue({
        el: "#vue-registrator",
        components: {
            colorPicker
        },
        data: {
            mainColor: "#1e62a6",
            value: 210,
            saturation: 69,
            lightness: 38,
            
        },
        methods: {
            onChangeColor(color) {
                this.mainColor = color;
            }
        }
    })
}



// WEBPACK FOOTER //
// ./vue/registrator.js